/* Yo Renazco — interacciones (vanilla, sin librerías) */
(function () {
  /* En la página de venta (html.yr-sin-anim) todo se muestra de inmediato: menos trabajo para celulares lentos */
  var sinAnim = document.documentElement.classList.contains('yr-sin-anim');
  var reduce = sinAnim || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('yr-js');

  /* ---------- Palabras que suben (títulos) ---------- */
  function initSplit(root) {
    if (sinAnim) return;
    (root || document).querySelectorAll('[data-yr-split]:not([data-yr-done])').forEach(function (el) {
      el.setAttribute('data-yr-done', '');
      var i = 0;
      function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
              var w = document.createElement('span');
              w.className = 'yr-word';
              var inner = document.createElement('span');
              inner.style.setProperty('--w', i++);
              inner.textContent = part;
              w.appendChild(inner);
              frag.appendChild(w);
            });
            child.parentNode.replaceChild(frag, child);
          } else if (child.nodeType === 1 && child.tagName !== 'BR') {
            walk(child);
          }
        });
      }
      walk(el);
    });
  }

  /* ---------- Reveals con un solo observer ---------- */
  var io = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-yr-reveal], [data-yr-split], [data-yr-inview]');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px 6% 0px', threshold: 0.01 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Cifras animadas ---------- */
  function initCount(root) {
    (root || document).querySelectorAll('[data-yr-count]').forEach(function (el) {
      var target = parseFloat(el.getAttribute('data-yr-count')) || 0;
      if (reduce || !('IntersectionObserver' in window)) { el.textContent = target; return; }
      el.textContent = '0';
      var o = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        o.disconnect();
        var t0 = performance.now(), dur = 1600;
        (function step(t) {
          var p = Math.min(1, (t - t0) / dur);
          var v = 1 - Math.pow(1 - p, 4);
          el.textContent = Math.round(target * v);
          if (p < 1) requestAnimationFrame(step);
        })(t0);
      }, { threshold: 0.5 });
      o.observe(el);
    });
  }

  /* ---------- Parallax suave + escena sticky (un solo bucle) ---------- */
  var parallaxEls = [], scenes = [], ticking = false;
  function collectScroll() {
    parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-yr-parallax]'));
    scenes = Array.prototype.slice.call(document.querySelectorAll('[data-yr-scene]'));
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var vh = window.innerHeight;
      parallaxEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var k = parseFloat(el.getAttribute('data-yr-parallax')) || 0;
        if (window.innerWidth < 750 && el.classList.contains('yr-hero__bg')) { el.style.transform = ''; return; }
        var c = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (c * k * -1).toFixed(1) + 'px,0)';
      });
      scenes.forEach(function (sc) {
        var r = sc.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, (vh * 0.5 - r.top) / (r.height - vh * 0.3)));
        sc.style.setProperty('--yr-p', p.toFixed(3));
        sc.style.setProperty('--yr-scene-scale', (1.12 - p * 0.12).toFixed(3));
        var items = sc.querySelectorAll('.yr-scene__item'), best = null, bestD = 1e9;
        items.forEach(function (it) {
          var ir = it.getBoundingClientRect();
          var d = Math.abs(ir.top + ir.height / 2 - vh / 2);
          if (d < bestD) { bestD = d; best = it; }
        });
        items.forEach(function (it) { it.classList.toggle('is-active', it === best); });
      });
    });
  }

  /* ---------- Tarjetas que se inclinan ---------- */
  function initTilt(root) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    (root || document).querySelectorAll('[data-yr-tilt]').forEach(function (el) {
      var max = parseFloat(el.getAttribute('data-yr-tilt')) || 6;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateX(' + (-y * max).toFixed(2) + 'deg) rotateY(' + (x * max).toFixed(2) + 'deg) translateY(-4px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Botones magnéticos ---------- */
  function initMagnet(root) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    (root || document).querySelectorAll('[data-yr-magnet]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        el.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.18).toFixed(1) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.25).toFixed(1) + 'px)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Acordeones ---------- */
  function initAcc(root) {
    (root || document).querySelectorAll('.yr-acc__btn:not([data-yr-bound])').forEach(function (btn) {
      btn.setAttribute('data-yr-bound', '');
      btn.addEventListener('click', function () {
        var acc = btn.closest('.yr-acc');
        var open = !acc.classList.contains('is-open');
        var group = acc.parentElement;
        /* Si se cierra uno de ARRIBA, se cierra al instante y se corrige el scroll una sola vez
           (corregir en cada cuadro hacía "temblar" la página en iPhone con la barra que aparece/desaparece) */
        var top0 = btn.getBoundingClientRect().top, arriba = false;
        if (group && group.hasAttribute('data-yr-single')) {
          group.querySelectorAll('.yr-acc.is-open').forEach(function (o) {
            if (o === acc) return;
            var p = o.querySelector('.yr-acc__panel');
            if (o.compareDocumentPosition(acc) & Node.DOCUMENT_POSITION_FOLLOWING) { arriba = true; p.style.transition = 'none'; }
            o.classList.remove('is-open'); o.querySelector('.yr-acc__btn').setAttribute('aria-expanded', 'false');
            if (p.style.transition) { void p.offsetHeight; requestAnimationFrame(function () { p.style.transition = ''; }); }
          });
        }
        if (arriba) { var d = btn.getBoundingClientRect().top - top0; if (Math.abs(d) > 0.5) window.scrollBy(0, d); }
        acc.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- Flechas de carrusel ---------- */
  function initArrows(root) {
    (root || document).querySelectorAll('[data-yr-scroller]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-yr-track]');
      if (!track) return;
      wrap.querySelectorAll('[data-yr-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          var card = track.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 18 : 300;
          track.scrollBy({ left: step * parseInt(b.getAttribute('data-yr-dir'), 10), behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-yr-gallery]').forEach(function (g) {
      var track = g.querySelector('.yr-gallery__track');
      if (!track) return;
      var thumbs = g.querySelectorAll('.yr-thumb');
      var dots = g.querySelectorAll('.yr-gallery__dots span');
      function setActive(i) {
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        g.classList.toggle('is-vid', !!track.children[i] && !!track.children[i].querySelector('[data-yr-vid]'));
        g.querySelectorAll('[data-yr-vid]').forEach(function (v) {
          if (v.parentNode === track.children[i]) { if (!v.src) v.src = v.getAttribute('data-src'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else if (!v.paused) v.pause();
        });
      }
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          track.scrollTo({ left: track.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' });
          setActive(i);
        });
      });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); });
      }, { passive: true });
      g.goTo = function (i) { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); setActive(i); };
    });
  }

  /* ---------- Formulario de compra (variantes, cantidad, carrito) ---------- */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }
  function initBuy(root) {
    (root || document).querySelectorAll('[data-yr-buy]').forEach(function (box) {
      var form = box.querySelector('form');
      if (!form || form.hasAttribute('data-yr-bound')) return;
      form.setAttribute('data-yr-bound', '');
      var idInput = form.querySelector('input[name="id"]');
      var btn = form.querySelector('[data-yr-add]');
      var btnLabel = btn ? btn.querySelector('span') : null;
      var msg = box.querySelector('.yr-buy__msg');
      var dataEl = box.querySelector('script[data-yr-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : null;
      var fmt = box.getAttribute('data-money-format');
      var txtAdd = box.getAttribute('data-txt-add'), txtSold = box.getAttribute('data-txt-sold');

      box.querySelectorAll('.yr-qty').forEach(function (q) {
        var input = q.querySelector('input');
        q.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10));
            input.value = v;
          });
        });
      });

      function update(v) {
        if (!v) { if (btn) btn.disabled = true; if (btnLabel) btnLabel.textContent = txtSold; return; }
        idInput.value = v.id;
        box.querySelectorAll('[data-yr-color-nombre]').forEach(function (n) { n.textContent = v.option1; });
        /* Vista previa del color junto a las bolitas (en celular la galería queda lejos) */
        var pv = box.querySelector('[data-yr-cprev]'), fm = v.featured_media && v.featured_media.preview_image;
        if (pv && fm && fm.src) { var pi = pv.querySelector('img'); pi.src = fm.src + (fm.src.indexOf('?') > -1 ? '&' : '?') + 'width=400'; pi.alt = v.option1; pv.hidden = false; pv.classList.remove('is-pop'); void pv.offsetWidth; pv.classList.add('is-pop'); }
        document.querySelectorAll('[data-yr-vcolor] input').forEach(function (i) { i.checked = i.value === v.option1; });
        document.querySelectorAll('[data-yr-vcolor-nombre]').forEach(function (n) { n.textContent = v.option1; });
        box.querySelectorAll('[data-yr-price]').forEach(function (p) { p.textContent = money(v.price, fmt); });
        document.querySelectorAll('[data-yr-sticky-price]').forEach(function (p) { p.textContent = money(v.price, fmt); });
        box.querySelectorAll('[data-yr-compare]').forEach(function (p) {
          p.textContent = v.compare_at_price > v.price ? money(v.compare_at_price, fmt) : '';
        });
        if (btn) { btn.disabled = !v.available; if (btnLabel) btnLabel.textContent = v.available ? txtAdd : txtSold; }
        if (v.featured_media && box.closest('.yr-section')) {
          var g = box.closest('.yr-section').querySelector('[data-yr-gallery]');
          var idx = g ? Array.prototype.map.call(g.querySelectorAll('.yr-slide'), function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(v.featured_media.id)) : -1;
          if (g && idx > -1 && g.goTo) g.goTo(idx);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (variants) {
        box.querySelectorAll('.yr-option input').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var sel = Array.prototype.map.call(box.querySelectorAll('.yr-option'), function (fs) {
              var c = fs.querySelector('input:checked'); return c ? c.value : null;
            });
            update(variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); }));
          });
        });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!btn || btn.disabled) return;
        btn.classList.add('is-loading');
        if (msg) msg.textContent = '';
        var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        var fd = new FormData(form);
        if (cart && cart.getSectionsToRender) {
          fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
          fd.append('sections_url', window.location.pathname);
          if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
        }
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) { if (msg) msg.textContent = res.description || res.message; return; }
          if (cart && cart.renderContents && res.sections) {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(res);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        }).catch(function () {
          form.submit();
        }).finally(function () { btn.classList.remove('is-loading'); });
      });
    });

    /* Barra de compra fija: sigue al botón real (Releasit o nativo) */
    document.querySelectorAll('[data-yr-sticky-atc]').forEach(function (bar) {
      var target = document.getElementById(bar.getAttribute('data-yr-sticky-atc'));
      if (!target) return;
      var footer = document.querySelector('.footer, .yr-footer');
      function mainEl() {
        var rsi = target.querySelector('form #rsi_buy_now_button');
        if (rsi && rsi.offsetParent !== null) return rsi;
        var add = target.querySelector('[data-yr-add]');
        if (add && add.offsetParent !== null) return add;
        var app = target.querySelector('[data-yr-app]');
        return app && app.offsetParent !== null ? app : target;
      }
      var tick = false;
      function paint() {
        tick = false;
        var past = mainEl().getBoundingClientRect().bottom < 0;
        /* Página de venta: el bloque de compra está al final, así que la barra aparece al pasar el botón de arriba
           y se oculta mientras el botón real está en pantalla */
        var desde = bar.getAttribute('data-yr-sticky-desde');
        var ancla = desde && document.querySelector(desde);
        if (ancla) {
          var r = mainEl().getBoundingClientRect();
          past = ancla.getBoundingClientRect().bottom < 0 && !(r.top < window.innerHeight && r.bottom > 0);
          /* Desde el primer scroll: visible salvo cuando el botón de compra de arriba o el real están en pantalla */
          if (bar.hasAttribute('data-yr-sticky-temprano')) {
            var a = ancla.getBoundingClientRect();
            var pt = document.querySelector('.yr-venta__ptop-btn'), p = pt ? pt.getBoundingClientRect() : null;
            past = window.scrollY > 120 && !(a.top < window.innerHeight && a.bottom > 0) && !(r.top < window.innerHeight && r.bottom > 0) && !(p && p.bottom > 0 && p.top < window.innerHeight);
          }
        }
        var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
        bar.classList.toggle('is-visible', past && !nearFooter);
      }
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(paint); } }, { passive: true });
      window.addEventListener('resize', paint);
      paint();
      var b = bar.querySelector('button');
      if (b) b.addEventListener('click', function () { openBuy(target); });
    });
  }

  /* ---------- Abrir la compra (Releasit si existe; si no, el botón nativo) ---------- */
  function buyBox() {
    var f = document.querySelector('[data-yr-buy] form');
    return f ? f.closest('[data-yr-buy]') : null;
  }
  function openBuy(box) {
    box = box || buyBox();
    if (!box) return false;
    var rsi = box.querySelector('form #rsi_buy_now_button');
    if (rsi && rsi.offsetParent !== null) { rsi.click(); return true; }
    var app = box.querySelector('[data-yr-app] button, [data-yr-app] a, [data-yr-app] [role="button"]');
    var row = box.querySelector('.yr-buy__row');
    if (app && row && row.classList.contains('yr-hidden')) { app.click(); return true; }
    var add = box.querySelector('[data-yr-add]');
    if (add && !add.disabled && add.offsetParent !== null) { add.click(); return true; }
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }
  function initComprar() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#comprar"], [data-yr-comprar]');
      if (!a) return;
      var box = buyBox();
      if (!box) return; /* en otra página: el enlace lleva a la página del producto */
      e.preventDefault();
      openBuy(box);
    });
    if (location.hash === '#comprar') {
      var t = document.getElementById('comprar');
      if (t) setTimeout(function () { t.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 400);
    }
  }

  /* ---------- Fecha estimada de entrega (días hábiles, lunes a viernes) ---------- */
  function initETA(root) {
    (root || document).querySelectorAll('[data-yr-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 2, max = parseInt(el.getAttribute('data-max'), 10) || 4;
      var txt = el.getAttribute('data-txt');
      if (!txt || txt.indexOf('[desde]') < 0) return;
      function add(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
      function fmt(d) { try { return d.toLocaleDateString('es-EC', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/\./g, ''); } catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); } }
      var span = el.querySelector('span');
      if (span) span.innerHTML = txt.replace('[desde]', '<b>' + fmt(add(min)) + '</b>').replace('[hasta]', '<b>' + fmt(add(Math.max(min, max))) + '</b>');
    });
  }

/* ---------- Comparador antes / después ---------- */
  function initBA(root) {
    (root || document).querySelectorAll('[data-yr-ba]:not([data-yr-bound])').forEach(function (ba) {
      ba.setAttribute('data-yr-bound', '');
      var range = ba.querySelector('.yr-ba__range');
      function set(v) { ba.style.setProperty('--pos', v + '%'); }
      range.addEventListener('input', function () { set(range.value); });
      if (reduce || !('IntersectionObserver' in window)) return;
      var start = parseFloat(range.value) || 50;
      var o = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return;
        o.disconnect();
        var keys = [start, 22, 78, start], t0 = null, dur = 2600;
        (function step(t) {
          if (t0 === null) t0 = t;
          if (ba.hasAttribute('data-touched')) return;
          var p = Math.min(1, (t - t0) / dur), seg = Math.min(2, Math.floor(p * 3)), lp = p * 3 - seg;
          var e = lp < .5 ? 4 * lp * lp * lp : 1 - Math.pow(-2 * lp + 2, 3) / 2;
          var v = keys[seg] + (keys[seg + 1] - keys[seg]) * e;
          set(v.toFixed(2)); range.value = v;
          if (p < 1) requestAnimationFrame(step);
        })(performance.now());
      }, { threshold: 0.6 });
      o.observe(ba);
      ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) { ba.addEventListener(ev, function () { ba.setAttribute('data-touched', ''); }, { passive: true }); });
    });
  }
/* ---------- Detectar botón de pago contra entrega (Releasit u otras apps) ---------- */
  function initCOD(root) {
    (root || document).querySelectorAll('[data-yr-buy]').forEach(function (box) {
      function check() { box.classList.toggle('yr-cod', !!box.querySelector('#rsi_buy_now_button')); }
      check();
      if ('MutationObserver' in window) new MutationObserver(check).observe(box, { childList: true, subtree: true });
    });
  }
  /* ---------- Carrusel de productos (autoplay + puntos + flechas + swipe) ---------- */
  function initCar(root) {
    (root || document).querySelectorAll('[data-yr-car]:not([data-yr-bound])').forEach(function (car) {
      car.setAttribute('data-yr-bound', '');
      var track = car.querySelector('[data-yr-car-track]');
      var slides = track ? track.children : [];
      if (!track || slides.length < 2) return;
      var dots = car.querySelectorAll('.yr-car__dots button');
      var speed = (parseInt(car.getAttribute('data-speed'), 10) || 0) * 1000;
      var idx = 0, timer = null, paused = false;
      function go(i) { idx = (i + slides.length) % slides.length; track.scrollTo({ left: track.clientWidth * idx, behavior: reduce ? 'auto' : 'smooth' }); }
      function mark() {
        var i = Math.round(track.scrollLeft / track.clientWidth); idx = i;
        Array.prototype.forEach.call(slides, function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });
      car.querySelectorAll('[data-yr-car-dir]').forEach(function (b) { b.addEventListener('click', function () { go(idx + parseInt(b.getAttribute('data-yr-car-dir'), 10)); restart(); }); });
      function restart() { clearInterval(timer); if (speed && !reduce) timer = setInterval(function () { if (!paused && !document.hidden) go(idx + 1); }, speed); }
      ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { car.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['pointerleave', 'focusout'].forEach(function (ev) { car.addEventListener(ev, function () { paused = false; }); });
      restart();
    });
  }
  /* ---------- Fotos diferidas: se descargan al estar a ~400 px de la pantalla ---------- */
  function initDefer(root) {
    var els = (root || document).querySelectorAll('img[data-yr-defer]');
    function load(img) { img.removeAttribute('data-yr-defer'); if (img.dataset.srcset) img.srcset = img.dataset.srcset; img.src = img.dataset.src; }
    if (!('IntersectionObserver' in window)) { els.forEach(load); return; }
    var o = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { load(e.target); o.unobserve(e.target); } });
    }, { rootMargin: '400px 0px' });
    els.forEach(function (el) { o.observe(el); });
  }
  function initAll(root) {
    initDefer(root);
    initSplit(root); initReveal(root); initCount(root); initTilt(root); initMagnet(root);
    initAcc(root); initArrows(root); initGallery(root); initBuy(root); initBA(root); initCOD(root); initETA(root); initCar(root);
    collectScroll(); onScroll();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    initComprar();
    /* Títulos de políticas en español (Shopify los pone en el idioma base de la tienda) */
    var pt = document.querySelector('.shopify-policy__title h1');
    if (pt) {
      var tr = { 'shipping policy': 'Política de envíos', 'refund policy': 'Cambios y devoluciones', 'privacy policy': 'Política de privacidad', 'terms of service': 'Términos del servicio', 'contact information': 'Contacto', 'contact': 'Contacto', 'legal notice': 'Aviso legal' };
      var k = pt.textContent.trim().toLowerCase();
      if (tr[k]) { pt.textContent = tr[k]; document.title = tr[k] + ' – ' + document.title.split('–').pop().trim(); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  });
  /* Editor de Shopify: reactivar al recargar una sección */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
